import React from 'react';
import { FaCartPlus, FaCreditCard } from 'react-icons/fa';
import { AiFillHome } from 'react-icons/ai';
import { IoIosPaper, IoMdCash, IoMdPeople, IoMdLaptop, IoMdSettings, IoMdStats } from 'react-icons/io';
import { RiArrowDownSFill, RiArrowUpSFill, RiArrowRightSFill } from 'react-icons/ri';

export const SidebarData = [
  {
    title: 'Thông tin tài khoản',
    path: '/accountinfo',
    icon: <AiFillHome />,
    iconClosed: <RiArrowDownSFill />,
    iconOpened: <RiArrowUpSFill />,
    arrow: <RiArrowRightSFill />
  
  },
  {
    title: 'Nạp tiền vào ví',
    path: '/',
    icon: <IoIosPaper />,
    iconClosed: <RiArrowDownSFill />,
    iconOpened: <RiArrowUpSFill />,
    arrow: <RiArrowRightSFill />
    
  },
  {
    title: 'Nạp app',
    path: '/rechargeSupme',
    icon: <FaCartPlus />,
    arrow: <RiArrowRightSFill />
  },
  // {
  //   title: 'Rút tiền',
  //   path: '/withdrawmoney',
  //   icon: <IoMdCash  />,
  //   arrow: <RiArrowRightSFill />
  // },
  {
    title: 'Cộng tác viên',
    path: '/collaborator',
    icon: <IoMdPeople />,
    arrow: <RiArrowRightSFill />
  },
  // {
  //   title: 'Thẻ cào',
  //   path: '/scratchcard',
  //   icon: <FaCreditCard />,
  //   iconClosed: <RiArrowDownSFill />,
  //   iconOpened: <RiArrowUpSFill />,
  //   arrow: <RiArrowRightSFill />
  // },
  {
    title: 'Đại lý',
    path: '/agency',
    icon: <IoMdLaptop />,
    arrow: <RiArrowRightSFill />
  },
  {
    title: 'Cài đặt',
    path: '/setting',
    icon: <IoMdSettings />,
    arrow: <RiArrowRightSFill />
  },
  {
    title: 'Thống kê',
    path: '/summary',
    icon: <IoMdStats  />,
    arrow: <RiArrowRightSFill />
  }

];